import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { imeiLookupModal } from 'config';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid-extended';
import { ManageInventoryService } from '../shared/providers/manage-inventory.service';
import { ImeiLookupModel } from './imeilookup.model';
import { ImeiNumberService } from './shared/imeilookup-modal.service';

@Component({
  selector: 'app-imeilookup-modal',
  templateUrl: './imeilookup-modal.component.html',
  styleUrls: ['./imeilookup-modal.component.scss'],
  providers: [ImeiNumberService],
  encapsulation: ViewEncapsulation.None
})
export class ImeilookupModalComponent implements OnInit {

  @Input()
  modalPopupObject: ImeiLookupModel;
  @Input() triggerElement: any;

  @Output()
  modalOutput: EventEmitter<boolean>;

  focusabbleElements: any;
  imeiNumbertoFormate: FormControl;
  noRecordsFound: boolean = false;
  systemError: boolean = false;
  validNumberError: boolean = false;
  recordsFound: boolean = false;
  imeiNumber: any;
  imeiModalData: any;
  imeiDetails: any;
  customGridOptions = new GridOptionsModel();
  gridOptions: GridOptionsModel;
  customDefs: any = imeiLookupModal;
  displayRecords: boolean = false;
  static SANITIZE;
  singleFanInventory: any;

  constructor(private el: ElementRef, private utilityService: UtilityService, private imeiNumberService: ImeiNumberService,
    private router: Router, private manageInventoryService: ManageInventoryService, private _sanitizer: DomSanitizer,
    private pageLoaderService: PageLoaderService, private route: ActivatedRoute) {
    this.modalOutput = new EventEmitter<boolean>();
    ImeilookupModalComponent.SANITIZE = _sanitizer;
  }

  ngOnInit() {
    this.imeiModalData = this.route.snapshot.data.pageData.manageInventory;
    document.body.classList.add('modal-open');
    this.initImeiNumberformControlObj();
  }

  btnAction(value) {
    if (value === false) {
      document.body.classList.remove('modal-open');
      this.modalOutput.emit(value);
      this.focusabbleElements = undefined;
      if (this.triggerElement) {
        this.triggerElement.focus();
      }
    } else {
      this.focusabbleElements = undefined;
      if (this.triggerElement) {
        this.triggerElement.focus();
      }
    }
  }

  loadFocustelements() {
    if (!this.focusabbleElements) {
      const focusableEls = this.utilityService.getFocusableElements(this.el);
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      this.focusabbleElements[0].focus();
    }
  }

  handleKeydown(event) {
    if(event.keyCode === KEY_CONFIG.enter ){
    event.stopPropagation();
    return;
    }
    if(event.keyCode === KEY_CONFIG.enter ||event.keyCode === KEY_CONFIG.escapeKey) {
    this.modalOutput.emit(false);
    this.focusabbleElements = undefined;
    if (this.triggerElement) {
    this.triggerElement.focus();
    }
    event.preventDefault();
    event.stopPropagation();
    return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
    }

  initImeiNumberformControlObj() {
    this.imeiNumbertoFormate = new FormControl();
  }

  handleImeiFieldChange() {
    this.noRecordsFound = false;
    this.systemError = false;
    this.validNumberError = false;
  }

  imeiNumberLookUp(imeiNumber) {
    if (imeiNumber && (imeiNumber.length === 14 || imeiNumber.length === 15)) {
      if (this.utilityService.getEnvConfig().useMock) {
        this.imeiNumberService.getImeiNumbers(this.utilityService.getEnvConfig().imeiNumberUrl).subscribe(response => {
          this.imeiDetails = response;
          //sessionStorage.setItem('ctnDetails', JSON.stringify(this.imeiDetails.ctnDetailsResponseList));
          if (this.imeiDetails.ctnDetailsResponseList.length === 1) {
            if (this.imeiDetails.ctnDetailsResponseList[0].deviceInfo.imei === imeiNumber) {
              this.btnAction(false);
              this.recordsFound = true;
              this.displayRecords = false;
              this.noRecordsFound = false;
              sessionStorage.setItem('ctnDetails', JSON.stringify(this.imeiDetails.ctnDetailsResponseList[0]));
              this.manageInventoryService.setSelectedCtn(this.imeiDetails.ctnDetailsResponseList[0].ctn);
              this.router.navigate(['manageInventory/ctnInfo']);
            } else {
              this.recordsFound = false;
              this.displayRecords = false;
              this.noRecordsFound = true;
            }
          } else if (this.imeiDetails.ctnDetailsResponseList.length > 1) {
            this.btnAction(true);
            this.recordsFound = true;
            this.displayRecords = true;
            this.noRecordsFound = false;
            sessionStorage.setItem('fullctnDetails', JSON.stringify(this.imeiDetails.ctnDetailsResponseList));
            this.initgrid();

          } else {
            this.recordsFound = false;
            this.displayRecords = false;
            this.noRecordsFound = true;
          }
          this.pageLoaderService.setPageLoaderStatus(true);

          //old code start
          // this.manageInventoryService.setSelectedCtn(this.imeiDetails.ctnDetailsResponseList[0].ctn);
          // if (this.imeiDetails.ctnDetailsResponseList[0].deviceInfo.imei === imeiNumber) {
          //   this.btnAction(false);
          //   this.recordsFound = true;
          //   this.noRecordsFound = false;
          //   sessionStorage.setItem('ctnDetails', JSON.stringify(this.imeiDetails.ctnDetailsResponseList[0]));
          //   this.router.navigate(['manageInventory/ctnInfo']);
          // } else {
          //   this.recordsFound = false;
          //   this.noRecordsFound = true;
          // }
          // this.pageLoaderService.setPageLoaderStatus(true);
          //old code end
        }, error => {
          if (error.status === 400) {
            this.recordsFound = false;
            this.noRecordsFound = true;
          } else {
            this.systemError = true;
          }
        });
      } else {
        this.pageLoaderService.setPageLoaderStatus(false);
        this.validNumberError = false;
        this.imeiNumberService.getImeiNumbers(this.utilityService.getEnvConfig().imeiNumberUrl);
        this.manageInventoryService.getImeiDetails(imeiNumber)
          .subscribe(response => {
            //let imeiArrayLength = response.ctnDetailsResponseList.length;
            //this.imeiDetails = response.ctnDetailsResponseList[imeiArrayLength-1];
            //this.manageInventoryService.setSelectedCtn(this.imeiDetails.ctn);
            this.imeiDetails = response;
            if (this.imeiDetails.ctnDetailsResponseList.length === 1) {
              if (this.imeiDetails.ctnDetailsResponseList[0].deviceInfo.imei === imeiNumber) {
                this.btnAction(false);
                this.recordsFound = true;
                this.displayRecords = false;
                this.noRecordsFound = false;
                sessionStorage.setItem('ctnDetails', JSON.stringify(this.imeiDetails.ctnDetailsResponseList[0]));
                this.manageInventoryService.setSelectedCtn(this.imeiDetails.ctnDetailsResponseList[0].ctn);
                this.router.navigate(['manageInventory/ctnInfo']);
              } else {
                this.recordsFound = false;
                this.displayRecords = false;
                this.noRecordsFound = true;
              }
            } else if (this.imeiDetails.ctnDetailsResponseList.length > 1) {
              this.btnAction(true);
              this.recordsFound = true;
              this.displayRecords = true;
              this.noRecordsFound = false;
              sessionStorage.setItem('fullctnDetails', JSON.stringify(this.imeiDetails.ctnDetailsResponseList));
              this.initgrid();

            } else {
              this.recordsFound = false;
              this.displayRecords = false;
              this.noRecordsFound = true;
            }

            this.pageLoaderService.setPageLoaderStatus(true);
          }, error => {
            if (error.status === 400 || error.status === 404) {
              this.recordsFound = false;
              this.noRecordsFound = true;
            } else {
              this.systemError = true;
            }
            this.pageLoaderService.setPageLoaderStatus(true);
          });
      }
    } else {
      this.validNumberError = true;
    }
  }

  initgrid() {

    this.customGridOptions.enableFiltering = false;
    this.customGridOptions.enableSorting = true;
    this.customGridOptions.multiSelect = false;
    const pagination = {
      recordsPerPage: 3,
      currentPage: 1,
      isServerSide: true,
      totalRecords: 3,
      hideGoToPage: true
    };
    sessionStorage.setItem('totalImeis', this.imeiDetails.ctnDetailsResponseList.length);
    this.customGridOptions.Paginations = pagination;
    this.customGridOptions.gridData = this.imeiDetails.ctnDetailsResponseList.slice(0, 3);
    this.customGridOptions.columnDefinitions = this.customDefs.columnDefinitions;
    this.customGridOptions.callbacks = {
      callBackAppNameCellTemplate: this.callBackAppNameCellTemplate,
      callBackProfileStatus: this.callBackProfileStatus,
      callBackImei: this.callBackImei
    };
    this.customGridOptions.disableGrid = false;
    this.customGridOptions.disableRow = false;
    this.customGridOptions.disableRowCondition = { field: '', value: '' };
    this.gridOptions = this.customGridOptions;

  }

  callBackAppNameCellTemplate(element, row, field, currentElem, type, col) {
    if (type === 'template') {
      if (row.ctn == null || row.ctn == "" || row.ctn == "Unknown") {
        //row.ctn = "Unknown";
        const formatctnNumber = "Unknown";
        return ImeilookupModalComponent.SANITIZE.bypassSecurityTrustHtml(` <a href='javascript:void(0)' tabindex="0" 
        class='ctn-number'>${formatctnNumber}</a><p class="username">${row.userName}</p>`);
      } else {
        const formatctnNumber = row.ctn.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3');
        return ImeilookupModalComponent.SANITIZE.bypassSecurityTrustHtml(` <a href='javascript:void(0)' tabindex="0" 
        class='ctn-number'>${formatctnNumber}</a><p class="username">${row.userName}</p>`);
      }
    } else if (type.target.classList.contains('ctn-number')) {
      currentElem.onDataChange.emit({ data: row, type: 'ctnInfo' });
    }
  }

  callBackImei(element, row, field, currentElem, type, col) {
    let imei = row.deviceInfo.imei;
    //row.imei = imei;
    return `<span class="custumgrid-field">${imei}</span>`;
  }

  callBackProfileStatus(element, row, field, currentElem) {
    const colorStatus = row.ctnStatus.enrollmentStatus.replace(/_/g, '-').toLowerCase();
    //let imei = row.deviceInfo.imei;
    //row.imei = imei;
    let status = row.ctnStatus.enrollmentStatus.replace(/_/g, ' ');
    if (status === 'ENROLLED ACTIVE') {
      status = 'Enrolled, active';
    } else if (status === 'OUT OF COMPLIANCE') {
      status = 'Not compliant';
    } else if (status === 'ENROLLED NOT ACTIVE') {
      status = 'Enrolled, not active';
    } else if (status === 'NOT ENROLLED') {
      status = 'Not enrolled';
    } else if (status === 'Claimed Android™') {
      status = 'claimed (Android™)';
    } else if (status === 'Claimed Samsung') {
      status = 'claimed (Samsung)';
    } else if (status === 'Claimed Apple') {
      status = 'claimed (Apple)';
    } else if (status === 'Not Claimed' || status === 'CLAIM INITIATED') {
      status = 'not claimed';
    }
    return `<span class='${colorStatus} color-square custumgrid-field'></span><span class="custumgrid-field">${status}</span>`;
  }

  onRowClick(action) {
    if (action.type === 'ctnInfo') {
      this.btnAction(false);
      this.manageInventoryService.setSelectedCtn(action.data.ctn);
      sessionStorage.setItem('ctnDetails', JSON.stringify(action.data));
      sessionStorage.getItem('ProfileID') ? sessionStorage.removeItem('ProfileID') : null;
      sessionStorage.setItem('ProfileID', action.data.profileId);
      this.router.navigate(['manageInventory/ctnInfo']);
    }
  }

}
